import React, { useContext, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {
  channelAdminFetcher,
  channelFetcher,
  subscribersFetcher,
} from "../../api/requests";
import { useToaster } from "../../context/toaster";
import { ProfileContext } from "../../context/profile";
import Container from "react-bootstrap/Container";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function VideoUploadForm() {
  const [loading, setLoading] = useState(false);
  const [video, setVideo] = useState({
    channel: null,
    admin: null,
  });
  const { addMessage } = useToaster();
  const [subscribers, setSubscribers] = useState([]);
  const { id } = useParams();

  const handleChange = (name, value) => {
    setVideo({ ...video, [name]: value });
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleUpload = async () => {
    if (!video.admin) {
      showToast("error", "انتخاب ادمین اجباری است.");
      return;
    }

    const formData = new FormData();
    formData.append("channel", id);
    formData.append("admin", Number(video.admin));

    try {
      setLoading(true);
      const res = await channelAdminFetcher.post(formData);
      setLoading(false);
      if (res) {
        showToast("success", "ادمین مورد نظر شما با موفقیت انتخاب شد.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Admin error:", error);
      showToast(
        "error",
        Object.values(error.response.data)[0] ??
          "خطایی رخ داده است، دوباره تلاش کنید."
      );
    }
  };

  const getChannelsSubs = async () => {
    try {
      const subs = await subscribersFetcher.getChannelsSubscriptions(id);
      setSubscribers(subs?.results);
    } catch (err) {
      console.error(err);
      setSubscribers([]);
    }
  };

  useEffect(() => {
    getChannelsSubs();
  }, [video.channel]);

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          // maxWidth: "1500px",
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row
            style={{ /*maxWidth: "1500px",*/ width: "100%", padding: "30px" }}
          >
            <Col lg={12}>
              <div className="osahan-form">
                <Row>
                  <Col>
                    <Form.Group controlId="admin">
                      <Form.Label>اعضاء</Form.Label>
                      <Form.Control
                        onChange={(e) =>
                          handleChange(
                            "admin",
                            e.target.value !==
                              "کلیک کنید و ادمین مورد نظر را انتخاب کنید"
                              ? e.target.value
                              : null
                          )
                        }
                        as="select"
                        className="custom-select"
                        custom
                      >
                        <option>
                          کلیک کنید و ادمین مورد نظر را انتخاب کنید
                        </option>
                        {subscribers?.length > 0 ? (
                          subscribers?.map((item, index) => (
                            <option
                              key={index}
                              value={item?.user?.id}
                              style={{ color: "#000" }}
                            >
                              {item?.user?.username}
                            </option>
                          ))
                        ) : (
                          <option disabled>کاربری عضو کانال شما نیست.</option>
                        )}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <div className="osahan-area text-center mt-3">
                <Button
                  variant="outline-primary"
                  onClick={handleUpload}
                  style={{
                    cursor: loading ? "wait" : "pointer",
                  }}
                >
                  {loading ? "لطفا منتظر بمانید..." : "ارسال"}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </ContentWrapper>
  );
}
